import React from "react";
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";
import CommonHomePageContent from "src/pages/HomePageContent/Common";
import HelperAnalyticsEvent from "src/support/HelperAnalyticsEvent";

const Other = (props) => {
  const { otherContentList, searchText } = props;

  const returnRedirectableUrl = (v) => {
    const rawPathName = new URL(v[1]?.url).pathname;
    return rawPathName;
  };

  const typeHeadSearchEvent = (obj) => {
    HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Other", obj?.name, new URL(obj?.url).pathname)
  }
  return (
    <>
      <div className="search-item-title text-uppercase">OTHER CONTENT</div>
      {Object.keys(otherContentList).length > 0 && (
        <>
          <div className="search-artical-list">
            {Object.keys(otherContentList).length > 0 &&
              Object.entries(otherContentList).map((v, i) => (
                <React.Fragment key={i}>
                  {i < 5 && (
                    <div className="search-artical-list-item">
                      <div className="search-artical-list-item-info">
                        <a onClick={() => typeHeadSearchEvent(v[1])} href={returnRedirectableUrl(v)}
                          className=" cursor-pointer"
                        >
                          <div className="search-artical-title">{v[1].name}</div>
                        </a>
                        <div className="search-artical-desc">
                          {v[1].shortDescription}
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
          <a
            href={
              HomePage.makeHomeTabsListRouteURL(
                CommonHomePageContent.chain_HomeTabList.CNT.param_value
              ) +
              "&__c_HomePageContent=ALCT&__c_HomePageContentTabList=OTR&search=" +
              searchText +
              "&viewAll=true"
            }
            className="text-center mt-auto pb-3 pt-3"
          >
            <div className="bs5 btn btn-sm btn-primary">VIEW ALL Results</div>
          </a>
        </>
      )}
      {Object.keys(otherContentList).length === 0 && (
        <>
          <NoContent />
        </>
      )}
    </>
  );
};

export default Other;
